<script setup lang="ts">
type TaskListData = App.StudentApp.Data.TaskListData;

import CardList from '@/components/studentParentApp/card/CardList.vue';
import CardListItem from '@/components/studentParentApp/card/CardListItem.vue';
import PageSection from '@/components/studentParentApp/PageSection/PageSection.vue';
import PageContainer from '@/components/studentParentApp/container/PageContainer.vue';
import StudentDashboard from '@/domains/student-app/components/tasks/StudentDashboard.vue';
import TaskItem from '@/domains/student-app/components/tasks/TaskItem.vue';
import EmptyState from '@/domains/student-app/components/tasks/EmptyState.vue';
import PlantPot from '@/images/plant-pot.svg';
import Button from '@/components/button/Button.vue';
import AngleRight from '@/icons/line/angle-right.svg';
import { ButtonColor, ButtonSize, ButtonVariant } from '@/hooks/useButtonClasses';

defineProps<{
  todoTasksCount: number;
  completedTasksCount: number;
  taskLists: TaskListData[];
}>();
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/student-parent.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <StudentDashboard :todoTasksCount="todoTasksCount" :completedTasksCount="completedTasksCount">
    <!-- Empty state when no task lists -->
    <template v-if="taskLists.length === 0">
      <PageContainer class="mb-5">
        <CardList>
          <template #header>
            <h2 class="text-xs font-bold uppercase leading-none text-slate-500">To-do</h2>
          </template>
          <CardListItem>
            <EmptyState
              :icon="PlantPot"
              :title="completedTasksCount ? 'Way to go!' : 'No to-do tasks'"
              titleColor="text-primary-800"
              :description="
                completedTasksCount
                  ? `You've done everything on your to-do list.`
                  : 'To-dos will appear on this tab'
              "
            />
          </CardListItem>
        </CardList>
      </PageContainer>
    </template>

    <!-- Task Lists -->
    <template v-for="(taskList, index) in taskLists" :key="taskList.title">
      <component :is="index === 0 ? PageContainer : PageSection">
        <CardList :class="{ 'mb-5': index === 0 }">
          <template #header>
            <h2 class="text-xs font-bold uppercase leading-none text-slate-500">
              {{ taskList.title }}
            </h2>
          </template>
          <CardListItem
            v-for="task in taskList.tasks"
            :key="task.id"
            :value="task.title"
            :href="route('tasks.show', { task: task.id })"
          >
            <TaskItem :task="task" />
          </CardListItem>
        </CardList>
      </component>
    </template>
    <PageSection class="grow">
      <Button
        :iconRight="AngleRight"
        :size="ButtonSize.lg"
        :variant="ButtonVariant.outlined"
        :color="ButtonColor.primary"
        class="w-full"
        @click="router.get(route('student.completed-tasks.show'))"
      >
        Completed items
      </Button>
    </PageSection>
  </StudentDashboard>
</template>
